import { render, staticRenderFns } from "./SublimeToolbar.vue?vue&type=template&id=4eb8c627"
import script from "./SublimeToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SublimeToolbar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports